"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _theme = require("../theme");
require("./button.css");
var _excluded = ["children", "className", "color", "href", "interactive", "loading", "loadingAriaLiveAnnouncement", "onClick", "tagName", "type", "visualStyle"];
/* eslint-disable max-statements, complexity */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var isReactComponent = function isReactComponent(component) {
  var _component$prototype;
  return typeof component === 'function' && (String(component).includes('return React.createElement') || Boolean((_component$prototype = component.prototype) === null || _component$prototype === void 0 ? void 0 : _component$prototype.isReactComponent));
};

/**
 * This component renders `button` tags by default or `a` if `href` is
 * provided. It also supports an arbitrary `tagName` prop for advanced usage, which can
 * support HTML tag names or React components like `Link`.
 */
var Button = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    color = _ref.color,
    href = _ref.href,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$loadingAriaLiveA = _ref.loadingAriaLiveAnnouncement,
    loadingAriaLiveAnnouncement = _ref$loadingAriaLiveA === void 0 ? 'Loading' : _ref$loadingAriaLiveA,
    onClick = _ref.onClick,
    tagName = _ref.tagName,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$visualStyle = _ref.visualStyle,
    visualStyle = _ref$visualStyle === void 0 ? 'default' : _ref$visualStyle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var tagNameRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return tagNameRef.current;
  });
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    timer = _useState2[0],
    setTimer = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showLoading = _useState4[0],
    setShowLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    height = _useState6[0],
    setHeight = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    style = _useState8[0],
    setStyle = _useState8[1];
  (0, _react.useEffect)(function () {
    var _tagNameRef$current;
    if ((_tagNameRef$current = tagNameRef.current) !== null && _tagNameRef$current !== void 0 && _tagNameRef$current.offsetHeight) {
      setHeight(tagNameRef.current.offsetHeight);
    }
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (loading !== showLoading) {
      setTimer(setTimeout(function () {
        return setShowLoading(!showLoading);
      }, 100));
      if (loading) {
        setStyle({
          width: height,
          height: height
        });
      } else {
        setStyle({
          height: height
        });
      }
    }
  }, [loading, showLoading]);
  var TagName = tagName || (href ? 'a' : 'button');
  var buttonType = TagName !== 'button' && TagName !== 'input' ? null : type;
  var notInteractive = Boolean(!['button', 'a', 'input'].includes(TagName) && !isReactComponent(tagName) || !interactive);
  var textOnly = visualStyle === 'textOnly';
  var textLink = visualStyle === 'textLink';
  var buttonOnClick = loading && !textOnly && !textLink ? function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
  } : onClick;
  var renderLoadingCircle = function renderLoadingCircle() {
    return showLoading && !otherProps.disabled ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "sb-button--loadingCircle"
    }) : null;
  };
  return /*#__PURE__*/_react["default"].createElement(_theme.ThemeContext.Consumer, null, function (theme) {
    var classList = textLink ? (0, _classnames["default"])('sb-textLink', className, {
      'sb-button--darkTheme': theme === _theme.themes.dark
    }) : (0, _classnames["default"])('sb-button', _defineProperty({
      'sb-button--default': visualStyle === 'default',
      'sb-button--positive': visualStyle === 'positive',
      'sb-button--text': visualStyle === 'textOnly',
      'sb-button--disabled': Boolean(otherProps.disabled),
      'sb-button--darkTheme': theme === _theme.themes.dark,
      'sb-button--rewardsDefault': theme === _theme.themes.rewards,
      'sb-button--gold': color === 'gold',
      'sb-button--black': color === 'black',
      'sb-button--white': color === 'white',
      'sb-button--houseGreen': color === 'houseGreen',
      'sb-button--red': color === 'red',
      'sb-button--loading': Boolean(loading && !otherProps.disabled && !textOnly),
      'sb-button--nonInteractive': notInteractive
    }, className, Boolean(className)));
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
      "aria-live": "polite",
      className: "hiddenVisually"
    }, loading ? loadingAriaLiveAnnouncement : ''), /*#__PURE__*/_react["default"].createElement(TagName, _extends({
      className: classList,
      href: href,
      onClick: buttonOnClick,
      ref: tagNameRef,
      style: _objectSpread({
        minWidth: height,
        minHeight: height
      }, style),
      type: buttonType
    }, otherProps), loading && !textLink && !textOnly && renderLoadingCircle(), (!loading || otherProps.disabled || textLink || textOnly) && children));
  });
});
/* eslint-enable max-statements, complexity */

Button.displayName = 'Button';
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  /**
   *  Optional color for the button. **Buttons are green by default.** Black buttons will be used
   * automatically if the button is in the Rewards Theme. White will be used automatically if the button is
   * in the Dark Theme. White and gold buttons should be used cautiously,
   * as they introduce contrast/accessibility issues with many background colors.
   */
  color: _propTypes["default"].oneOf(['gold', 'black', 'white', 'houseGreen', 'red']),
  /** The href of the link */
  href: _propTypes["default"].string,
  /**
   * If true, it shows a loading animation inside the button. Not shown if it's a text-only or text link button
   * or if the button is disabled.
   */
  loading: _propTypes["default"].bool,
  /**
   * Text that will be read aloud by a screen reader to announce that the button is in a loading state.
   */
  loadingAriaLiveAnnouncement: _propTypes["default"].any,
  /**
   * The visual style of the button.
   */
  visualStyle: _propTypes["default"].oneOf(['default', 'positive', 'textLink', 'textOnly']),
  /**
   * An optional HTML tagname or React component for the rendered element. This should generally be
   * `button` or `a`, unless there's a good reason to make it a non-interactive element. Defaults
   * to `button`, or `a` if an `href` is present.
   */
  tagName: _propTypes["default"].any,
  /**
   * An HTML button
   * [`type` attribute](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button).
   * Only applied if the `tagName` is `button` or `input`.
   */
  type: _propTypes["default"].oneOf(['button', 'reset', 'submit']),
  /**
   * Set to false, the button will appear visually interactive.
   */
  interactive: _propTypes["default"].bool
} : {};
var _default = exports["default"] = Button;